<div [ngClass]="{'item-fab': true, 'opacity': opacity}" [attr.data-color]="back"
     [style.--button-fab-size]="fabSize || null">
  <button id="btn-icon" [disabled]="disable" matTooltip="{{tooltip}}" [matTooltipClass]="'tooltip-default'" [matTooltipPosition]="'left'" mat-fab class="fab">
    <!-- <i id="btn-icon" class="{{icon}}"></i> -->
    <mmp5-mm-icons
      id="btn-icon" [icon]="icon">
    </mmp5-mm-icons>
  </button>
</div>
